import { isAfter, parseISO } from 'date-fns';

export type GoverningDeadline = {
  deadline: string | null | undefined;
  sourceItemName: string | null | undefined;
};

export const getIsAtRisk = ({
  latestFinish,
  planEndDate,
}: {
  latestFinish: string;
  planEndDate: string;
}) => {
  const latestFinishIso = parseISO(latestFinish);
  const planEnd = parseISO(planEndDate);

  return isAfter(latestFinishIso, planEnd);
};

export const getIsDeadlineAtRisk = ({
  forecastedFinish,
  deadline,
}: {
  forecastedFinish: string | null | undefined;
  deadline: string | null | undefined;
}): boolean => {
  if (!forecastedFinish || !deadline) return false;
  return getIsAtRisk({ latestFinish: forecastedFinish, planEndDate: deadline });
};

export const getGoverningDeadline = ({
  ownDeadline,
  ancestorDeadline,
  ancestorSourceItemName,
}: {
  ownDeadline: string | null | undefined;
  ancestorDeadline: string | null | undefined;
  ancestorSourceItemName: string | null | undefined;
}): GoverningDeadline => {
  if (!ancestorDeadline) return { deadline: ownDeadline, sourceItemName: null };
  if (!ownDeadline || !isAfter(parseISO(ancestorDeadline), parseISO(ownDeadline))) {
    return { deadline: ancestorDeadline, sourceItemName: ancestorSourceItemName ?? null };
  }
  return { deadline: ownDeadline, sourceItemName: null };
};
